/**
 * Hide Engraving Product (₹49.5) in GoKwik Cart
 * This script hides the separate engraving charge product from cart display
 */

(function() {
  'use strict';

  const ENGRAVING_VARIANT_ID = '48569060327647';

  function hideEngravingProducts() {
    // Method 1: Hide by variant ID
    const cartItems = document.querySelectorAll('[data-variant-id], [data-product-id]');
    
    cartItems.forEach(item => {
      const variantId = item.getAttribute('data-variant-id') || 
                       item.getAttribute('data-product-id') ||
                       item.dataset.variantId ||
                       item.dataset.productId;
      
      // Check both string and number formats
      if (variantId === ENGRAVING_VARIANT_ID || 
          variantId === parseInt(ENGRAVING_VARIANT_ID) ||
          String(variantId) === ENGRAVING_VARIANT_ID) {
        item.style.display = 'none !important';
        item.style.visibility = 'hidden';
        item.style.height = '0';
        item.style.overflow = 'hidden';
        console.log('BYOB: Hidden engraving product by variant ID');
      }
    });

    // Method 2: Hide by product title/name (for GoKwik)
    const allCartItems = document.querySelectorAll(
      '.cart-item, .cart__item, .side-cart__item, .drawer__item, ' +
      '.cart-drawer__item, .gokwik-cart-item, [class*="cart-item"], ' +
      '[class*="CartItem"], [class*="lineItem"]'
    );
    
    allCartItems.forEach(item => {
      const text = item.textContent || item.innerText || '';
      const html = item.innerHTML || '';
      
      // Check if this item is the engraving charge product
      if ((text.includes('Engraving Charge') || 
           text.includes('engraving-charge') ||
           html.includes('engraving-charge')) &&
          (text.includes('₹49') || text.includes('₹99') || 
           text.includes('49.5') || text.includes('99'))) {
        
        // Make sure it's not just a property, but an actual product line
        const hasProductLink = item.querySelector('a[href*="products"]');
        const hasImage = item.querySelector('img');
        
        if (hasProductLink || hasImage) {
          item.style.display = 'none !important';
          item.style.visibility = 'hidden';
          item.style.height = '0';
          item.style.overflow = 'hidden';
          console.log('BYOB: Hidden engraving product by title');
        }
      }
    });

    // Method 3: Hide by checking for _byob_engraving property
    const itemsWithProperties = document.querySelectorAll('[data-properties], [data-item-properties]');
    itemsWithProperties.forEach(item => {
      const props = item.getAttribute('data-properties') || item.getAttribute('data-item-properties') || '';
      if (props.includes('_byob_engraving') || props.includes('_for_product')) {
        item.style.display = 'none !important';
        item.style.visibility = 'hidden';
        item.style.height = '0';
        item.style.overflow = 'hidden';
        console.log('BYOB: Hidden engraving product by properties');
      }
    });
  }

  // Run immediately
  hideEngravingProducts();

  // Run after short delay (for GoKwik initialization)
  setTimeout(hideEngravingProducts, 500);
  setTimeout(hideEngravingProducts, 1000);
  setTimeout(hideEngravingProducts, 2000);

  // Run when cart updates
  document.addEventListener('cart:updated', () => {
    setTimeout(hideEngravingProducts, 300);
  });

  // Run when DOM changes (for GoKwik dynamic cart)
  const observer = new MutationObserver(() => {
    hideEngravingProducts();
  });

  // Start observing after page load
  window.addEventListener('load', () => {
    // Observe entire document for cart changes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

  // Also observe specific cart elements
  setTimeout(() => {
    const cartElements = document.querySelectorAll(
      '.cart-drawer, .side-cart, .cart, [class*="gokwik"], ' +
      '[class*="cart"], [id*="cart"]'
    );
    
    cartElements.forEach(element => {
      if (element) {
        observer.observe(element, {
          childList: true,
          subtree: true
        });
      }
    });
  }, 1000);

})();
